import dev from './constants.dev';
import prod from './constants.production';

const collections = {
    profiles: "profiles",
    parkings: "parkings",
    reservations: "reservations",
    logs: "logs"
};

const roles = {
    ADMIN: "admin",
    COMMUNITY: "community",
    PARTNER: "partner",
    WORKER: "worker",
    USER: "user"
};

const constants = {
    dev,
    prod
};

let globalConstants = {
    collections,
    roles
};

switch (process.env.NODE_ENV) {
    case 'development':
        globalConstants = { ...globalConstants, ...constants.dev };
        break;
    case 'test':
    case 'production':
        globalConstants = { ...globalConstants, ...constants.prod };
        break;
    default:
        break;

}

export default globalConstants;
